import React from 'react';
import { Label, Input, FormFeedback } from 'reactstrap';
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import PermisosListSelect from "../Permisos/PermisosListSelect.js"
import PermisosListDetail from "../Permisos/PermisosListDetail.js"
import api from "../../../api";

const PerfilFormSections = ({
    disabled = false,
    padre,
    permisosChecked,
    permisosDisabled,
    onPadreChange,
    onPadreLoaded,
    onPermisosChange,
    permisosMode = "select",
    autoFocusFirstField = false,
}) => {
    const PermisosList = permisosMode === "detail" ? PermisosListDetail : PermisosListSelect;

    return (
        <div className="ui-section-stack">
            <section className="ui-section-block">
                <p className="ui-section-label">Datos del perfil</p>
                <div className="ui-row-2">
                    <div className="ui-field">
                        <Label>Nombre</Label>
                        <Input disabled={disabled} type="text" name="nombre" autoFocus={autoFocusFirstField} data-auto-focus={autoFocusFirstField ? "true" : null}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                    <div className="ui-field">
                        <Label>Padre</Label>
                        <ParadigmaAsyncSeeker
                            disabled={disabled}
                            onExternalChange={onPadreLoaded}
                            onChange={onPadreChange}
                            fieldName={"padre_id"}
                            url={api.usuarios.grupos.select}
                            value={padre} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                </div>
            </section>

            <section className="ui-section-block">
                <p className="ui-section-label">Permisos</p>
                <div className="ui-row-1">
                    <div className="ui-field mb-1">
                        <div className="ui-scroll-list ui-permissions-list">
                            <PermisosList
                                fieldName={"permisos"}
                                disabledNodes={permisosDisabled}
                                onChange={onPermisosChange}
                                checked={permisosChecked} />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PerfilFormSections;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Perfiles/PerfilFormSections.js